
import { useState } from 'react';
import MainLayout from '@/components/layout/MainLayout';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import { toast } from '@/hooks/use-toast';
import { ReferralTab } from '@/components/sesh/ReferralTab';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { TransactionHistory } from '@/components/sesh/TransactionHistory';
import { SeshBalance } from '@/components/sesh/SeshBalance';
import { Coins, MessageSquare } from 'lucide-react';

const Feedback = () => {
  const [feedback, setFeedback] = useState('');
  const [activeTab, setActiveTab] = useState('feedback');
  const [submitting, setSubmitting] = useState(false);
  
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (feedback.trim()) {
      setSubmitting(true);
      
      // Simulate sending feedback
      await new Promise(resolve => setTimeout(resolve, 800));
      
      toast({
        title: "Feedback enviado",
        description: "Agradecemos pelo seu feedback!",
      });
      
      setFeedback('');
      setSubmitting(false);
    }
  };
  
  return (
    <MainLayout>
      <div className="container mx-auto p-6 max-w-2xl">
        <h1 className="text-2xl font-bold mb-2">feedback</h1>
        <p className="text-sm text-gray-500 mb-8">
          Compartilhe seus comentários e sugestões para nos ajudar a melhorar o Vive Calme
        </p>
        
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="grid grid-cols-2 mb-6">
            <TabsTrigger value="feedback" className="flex items-center gap-1">
              <MessageSquare size={14} />
              <span>Feedback</span>
            </TabsTrigger>
            <TabsTrigger value="indique" className="flex items-center gap-1">
              <Coins size={14} />
              <span>Indique Calme</span>
            </TabsTrigger>
          </TabsList>
          
          <TabsContent value="feedback" className="pt-2">
            <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow-sm border">
              <div className="mb-6">
                <label htmlFor="feedback" className="block text-sm font-medium text-gray-700 mb-2">
                  Seu feedback
                </label>
                <Textarea
                  id="feedback"
                  placeholder="Digite seu feedback aqui..."
                  value={feedback}
                  onChange={(e) => setFeedback(e.target.value)}
                  className="min-h-[150px]"
                />
              </div>
              
              <Button 
                type="submit" 
                className="w-full bg-brand-blue hover:bg-opacity-90 text-white"
                disabled={!feedback.trim() || submitting}
                isLoading={submitting}
                loadingText="Enviando..."
              >
                enviar feedback
              </Button>
            </form>
          </TabsContent>
          
          <TabsContent value="indique" className="pt-2">
            <div className="bg-white p-6 rounded-lg shadow-sm border">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-lg font-medium">Seu saldo</h3>
                <SeshBalance variant="default" animated />
              </div>
              
              <div className="mb-8">
                <ReferralTab />
              </div>
              
              <div className="mt-8">
                <h4 className="text-md font-medium mb-4">Histórico de transações</h4>
                <TransactionHistory limit={5} />
              </div>
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </MainLayout>
  );
};

export default Feedback;
